var vueTap = {};

function isPc() {
    const uaInfo = navigator.userAgent;
    const agents = ['Android', 'iPhone', 'Windows Phone', 'iPad', 'iPod'];
    let flag = true;
    for(let i = 0; i < agents.length; i++) {
        if(uaInfo.indexOf(agents[i] > 0)) {
            flag = false;
            break;
        }
    }
    return flag;
}

function isTap(self) {
    if(self.disabled) {
        return false;
    }
    const tapObj = self.tapObj;
    return self.time < 300 && Math.abs(tapObj.distanceX) < 10 && Math.abs(tapObj.distanceY) < 10;
}

function touchstart(e, self) {
    const touches = e.touches[0];
    const tapObj = self.tapObj;
    tapObj.pageX = touches.pageX;
    tapObj.pageY = touches.pageY;
    tapObj.clientX = touches.clientX;
    tapObj.clientY = touches.clientY;
    self.time = +new Date();
}

function touchend(e, self) {
    const touches = e.changedTouches[0];
    const tapObj = self.tapObj;
    self.time = +new Date() - self.time;
    tapObj.distanceX = tapObj.pageX - touches.pageX;
    tapObj.distanceY = tapObj.pageY - touches.pageY;
    if(!isTap(self)) {
        return;
    }
    self.handler(e);
}

vueTap.install = function(Vue) {
    Vue.directive('tap', {
        bind: function(el, binding) {
            el.tapObj = {};
            el.handler = function(e,isPc) {
                const value = binding.value;
                if(!value && el.href && !binding.modifiers.prevent) {
                    return window.location = el.href;
                }
                const tagName = e.target.tagName.toLocaleLowerCase();
                !isPc ? value.tapObj = el.tapObj : null;
                if(tagName === 'input' || tagName === 'textarea') {
                    return e.target.focus();
                }
                value.call(this);
            };
            if(isPc()) {
                el.addEventListener('click', function(e) {
                    if(binding.modifiers.stop) {
                        e.stopPropagation();
                    }
                    if(binding.modifiers.prevent) {
                        e.preventDefault();
                    }
                    el.handler(e, true);
                }, false);
            } else {
                el.addEventListener('touchstart', function(e) {
                    if(binding.modifiers.stop) {
                        e.stopPropagation();
                    }
                    if(binding.modifiers.prevent) {
                        e.preventDefault();
                    }
                    touchstart(e, el);
                }, false);

                el.addEventListener('touchend', function(e) {
                    try {
                        Object.defineProperty(e, 'currentTarget', {
                            value: el,
                            writable: true,
                            enumerable: true,
                            configurable: true
                        });
                    } catch(err) {
                        e.currentTarget = el;
                    }
                    e.preventDefault();
                    return touchend(e, el);
                }, false);
            }
        },
        componentUpdated: function(el, binding) {
            el.tapObj = {};
            el.handler = function(e, isPc) {
                const value = binding.value;
                if(!value && el.href && !binding.modifiers.prevent) {
                    return window.location = el.href;
                }
                if (!value && el.href && !binding.modifiers.prevent) {
                    return window.location = el.href;
                }
                !isPc ? value.tapObj = el.tapObj : null;
                value.call(this);
            };
        },
        unbind: function(el) {
            el.handler = null;
            el.tapObj = null;
        }
    });
}

export default vueTap;



// WEBPACK FOOTER //
// ./src/directives/vue-tap.js